import { render, staticRenderFns } from "./HubblePlot.vue?vue&type=template&id=5c98ef1d&scoped=true"
import script from "./HubblePlot.vue?vue&type=script&lang=ts"
export * from "./HubblePlot.vue?vue&type=script&lang=ts"
import style0 from "./HubblePlot.vue?vue&type=style&index=0&id=5c98ef1d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c98ef1d",
  null
  
)

export default component.exports